export let getId = (fechaSolicitud, idArticulo) => {
  let articuloId="";
  if (fechaSolicitud) {
    const tokens = fechaSolicitud.split(" ");
    const subTokens = tokens[0].split("-");
    const year = subTokens[0];
    let id = "";
    switch (idArticulo.length) {
      case 1:
        id = "000" + idArticulo;
        break;
      case 2:
        id = "00" + idArticulo;
        break;
      case 3:
        id = "0" + idArticulo;
        break;
      default:
        id = idArticulo;
        break;
    }
    articuloId = year + "-" + id;
  }
  return articuloId;
};
